module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "button-wrap toolbar",
    staticStyle: {
      "position": "absolute",
      "padding": "20px",
      "z-index": "9999"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCounter
    }
  }, [_vm._m(0), _vm._v("\n      导出小区抄表信息\n    ")])]), _vm._v(" "), _c('DataTablePage', {
    ref: "historyTable",
    attrs: {
      "mainColumn": "",
      "longColumn": "",
      "title": "用水历史",
      "label": "用水",
      "labelName": "",
      "resource": _vm.resource,
      "toolbar": _vm.customerId == 1 ? _vm.toolbar_manager : _vm.toolbar_customer,
      "operation": _vm.customerId == 1 ? _vm.operation_manager : _vm.operation_customer,
      "operationWidth": _vm.customerId == 1 ? 105 : 75,
      "updateList": _vm.updateList,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    },
    on: {
      "getData": _vm.getCountInitStatus,
      "checkGroupValue": _vm.checkGroupValue
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "btn-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-export"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-394549b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/WaterList.vue
// module id = 1737
// module chunks = 1